import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const SettingsPage = lazy(() => import("./pages/SettingsPage"));

export const settingsRoutes = [
  {
    path: PATHS.SETTINGS,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.SETTINGS}>
        <SettingsPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "user_profile", action: "view" },
      defaultView: true,
    },
  },
];
